import React from 'react';

type ProgressBarProps = {
  theme?: 'primary' | 'secondary';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  highestValue: number;
  lowestValue: number;
  actualValue: number;
};

const themeClasses = {
  primary: 'bg-primary',
  secondary: 'bg-secondary-500',
};

const backgroundClasses = {
  primary: 'bg-primary-500/20',
  secondary: 'bg-secondary-500/20',
};



const ProgressBar: React.FC<ProgressBarProps> = ({ theme = 'primary', size = 'md', highestValue, lowestValue, actualValue }) => {
  const calculatePercentage = (): number => {
    const range = highestValue - lowestValue;
    const adjustedValue = actualValue - lowestValue;
    return Math.min(Math.max((adjustedValue / range) * 100, 0), 100);
  };

  const sizeClass = {
    xs: 'h-2',
    sm: 'h-3',
    md: 'h-4',
    lg: 'h-5',
  }[size] || 'h-3';

  const percentage = calculatePercentage();

  return (
    <div className={`w-full ${backgroundClasses[theme]} rounded-full ${sizeClass}`}>
      <div
        className={`${themeClasses[theme]} rounded-full ${sizeClass}`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;